// extracted by mini-css-extract-plugin
module.exports = {"cardDetails":"carddetails_cardDetails__-5JCQ","cardDetailPrice":"carddetails_cardDetailPrice__zxAS8","cardDetailAttendees":"carddetails_cardDetailAttendees__l1C7t"};